// extracted by mini-css-extract-plugin
module.exports = {"Photos":"Home_Photos__2qqmJ","Photo":"Home_Photo__3Psok"};